module.exports = __webpack_public_path__ + "static/14-03fdb7903ac8d7d5ec2e6c89559a8ad0.jpg";